import { Input, Button, Space, Typography } from 'antd'
import { LinkOutlined } from '@ant-design/icons'
import useShortUrlChange from '@/hooks/useShorturlchange'
import { useState } from 'react'

const { Title, Text, Paragraph } = Typography

function ShorturlConversion() {
  const [longUrl, setLongUrl] = useState('')
  const [shortUrl, setShortUrl] = useState('')
  const { convertUrl } = useShortUrlChange()

  const handleConvert = async () => {
    const result = await convertUrl(longUrl);
    if (result) {
      setShortUrl(result);
    }
  };

    return (
      <Space direction='vertical' size='large' className='w-full'>
        <div>
          <Text strong style={{ fontSize: '18px' }}>长链接：</Text>
          <Input 
            placeholder="输入需要转换的长链接" 
            value={longUrl} 
            onChange={(e) => setLongUrl(e.target.value)}
            onPressEnter={handleConvert}
            prefix={<LinkOutlined />}
            size="large"
          />
        </div>
        <Button 
          type='primary' 
          size='medium'
          onClick={handleConvert}
          icon={<LinkOutlined />}
        >
          转换
        </Button>
        {shortUrl && (
          <div>
          <Text strong style={{ fontSize: '18px' }}>转换后的短链接：</Text>
          <Paragraph 
            copyable={shortUrl ? { 
              text: shortUrl,
              tooltips: ['点击复制', '已复制!'], 
            } : false}
            style={{ fontSize: '17px' }}
          >
            <a 
              href={shortUrl} 
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}
            >
              {shortUrl}
            </a>
          </Paragraph>
          <Text type="secondary" style={{ fontSize: '14px', marginTop: '4px', display: 'block' }}>
            说明：使用短链接前，可点击测试短链接是否可用
          </Text>
        </div>)}
      </Space>
    );
}

export default ShorturlConversion